import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { Device, from } from '@helpers/media';
import { rgba } from 'polished';
import styled from 'styled-components';
const Dots = styled.div `
  --dotActiveColour: currentColor;
  --dotBorderColour: currentColor;
  --dotBgColour: transparent;
  --visibleDots: 4;
  --dotSize: 18px;
  --dotActiveWidth: var(--dotSize);

  &[data-use-alt-theme='true'] {
    --dotSize: 6px;
    --dotActiveWidth: 18px;
    --dotBorderColour: ${rgba(brand.global.white, 0.25)};
  }

  @media ${from(Device.TabletLarge)} {
    --visibleDots: 10;
  }
`;
const DotsInner = styled.div `
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  justify-content: flex-start;
  gap: calc(var(--dotSize) / 2);
  max-width: calc((var(--dotSize) + var(--dotSize) / 2) * var(--visibleDots));
  overflow-x: auto;

  [data-use-alt-theme='true'] & {
    max-width: calc((var(--dotActiveWidth) + var(--dotActiveWidth) / 2) * var(--visibleDots));
  }

  [data-use-alt-theme='true'] & {
    gap: 16px;
  }

  @media ${from(Device.TabletLarge)} {
    gap: var(--dotSize);
  }

  &::-webkit-scrollbar {
    display: none;
  }
`;
const Dot = styled.span `
  ${transition('background-color, max-width')};

  display: block;
  max-width: var(--dotSize);
  width: var(--dotActiveWidth);
  height: var(--dotSize);
  flex-shrink: 0;
  border: 2px solid var(--dotBorderColour);
  border-radius: var(--dotSize);
  background-color: var(--dotBgColour);

  [data-use-alt-theme='true'] & {
    border: 2px solid var(--dotBorderColour);
  }

  &[aria-current='true'],
  &[data-active='true'] {
    background-color: var(--dotActiveColour);
    max-width: var(--dotActiveWidth);

    [data-use-alt-theme='true'] & {
      background-color: transparent;
      height: var(--dotActiveWidth);
      border-radius: var(--dotActiveWidth);
      border-color: var(--dotActiveColour);
    }
  }

  &[role='button'] {
    cursor: pointer;
  }
`;
export const DotsStyles = {
    Dot,
    DotsInner,
    Dots,
};
